import {Component, OnInit, Input, OnDestroy} from '@angular/core';
import {NgbDateParserFormatter} from '@ng-bootstrap/ng-bootstrap';
import {RouteService} from '../../shared/services/route.service';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {DataStorageService} from '../../shared/services/data-storage.service';
import {DispatchGroup} from '../../shared/models/dispatchGroup.model';
import {BlockedDate} from '../../shared/models/blockedDate.model';
import {LogCreate, Log} from '../../shared/models/log.model';
import {UserService} from '../../shared/services/user.service';
import {Subject, Subscription} from 'rxjs';
import {UserLogin} from '../../shared/models/user.model';
import {AuthenticationService} from '../../authentication/authentication.service';
import {DispatchGroupTitlePipe} from 'src/app/shared/pipes/dispatch-group-title.pipe';
import {takeUntil} from 'rxjs/operators';

@Component({
    selector: 'form-blocked-date',
    templateUrl: 'form-blocked-date.html',
    styleUrls: ['../../../assets/scss/plugins/_datepicker.scss']
})

export class FormBlockedDateComponent implements OnInit, OnDestroy {
    constructor(
        private routeService: RouteService,
        private dataStorageService: DataStorageService,
        private ngDateParserFormatter: NgbDateParserFormatter,
        private userService: UserService,
        private authenticationService: AuthenticationService) {
    }

    @Input() month;

    blockedForm: FormGroup;
    dispatchGroups: DispatchGroup[];
    dispatchGroupOptions: any = [];
    isAddOptions = [
        {'label': 'Block', 'value': 1, 'code': 'Block'},
        {'label': 'UnBlock', 'value': 0, 'code': 'UnBlock'}
    ];

    selectConfig: any = {
        labelField: 'label',
        valueField: 'value',
        searchField: ['label']
    };

    is_valid = false;

    logs: Log[] = [];

    ipAddress: string;

    user: UserLogin;

    private unsubscribe$: Subject<void> = new Subject<void>();

    ngOnInit() {

        this.dispatchGroups = this.routeService.getDispatchGroup();
        this.initDispatchGroupOptions(this.dispatchGroups);
        this.routeService.dispatchGroupsChanged
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(
                (dispatchGroups: DispatchGroup[]) => {
                    this.dispatchGroups = dispatchGroups;
                    this.initDispatchGroupOptions(dispatchGroups);
                }
            );

        this.initForm();

        this.blockedForm.valueChanges
            .pipe(takeUntil(this.unsubscribe$)).subscribe(
            () => {
                this.checkIsValid();
            }
        );

        this.dataStorageService.fetchLogBlockedDateMonth(this.month)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(
                (logs) => {
                    this.logs = logs;
                    // this.changeDetector.detectChanges();
                }
            );

        this.userService.setIPAddress().pipe(takeUntil(this.unsubscribe$)).subscribe((res: any) => {
                this.ipAddress = res.ip;
            }
        );
        this.authenticationService.user.pipe(takeUntil(this.unsubscribe$)).subscribe(user => {
            if (user) {
                this.user = user;
            }
        });
    }

    initForm() {
        this.blockedForm = new FormGroup({
            'is_add': new FormControl(1, Validators.required),
            'date': new FormControl(null, Validators.required),
            'dispatch_group_id': new FormControl(null, Validators.required)
        });
    }

    initDispatchGroupOptions(dispatchGroups: DispatchGroup[]) {
        for (const dispatchGroup of dispatchGroups) {
            this.dispatchGroupOptions.push({'label': dispatchGroup.title, 'value': dispatchGroup.id, 'code': dispatchGroup.title});
        }
    }

    checkIsValid() {
        // validators required not working for ng selectize
        const value = this.blockedForm.value;
        if (value.is_add && value.date && value.dispatch_group_id) {
            this.is_valid = true;
        } else {
            this.is_valid = false;
        }
    }

    onSubmit() {
        const value = this.blockedForm.value;
        value.date = this.ngDateParserFormatter.format(value.date);
        const newBlockedDate = new BlockedDate(value.date, value.dispatch_group_id);

        if (value.is_add === 1) {
            this.dataStorageService.createBlockedDate(newBlockedDate).pipe(takeUntil(this.unsubscribe$)).subscribe(
                responseData => {
                    if (responseData['error']) {
                        console.log('creating blocked_date error');
                    } else {
                        // save log
                        const newLog = new LogCreate(this.user.id, 'New blocked date ' + value.date + ' ' +
                            new DispatchGroupTitlePipe(this.routeService).transform(value.dispatch_group_id) + ' added. ', this.ipAddress);
                        newLog.blocked_date_id = responseData['id'];
                        this.dataStorageService.createLog(newLog)
                            .pipe(takeUntil(this.unsubscribe$))
                            .subscribe(response => {
                                alert('blocked_date created. ');
                                location.reload();
                            });
                    }
                }
            );
        } else {
            this.dataStorageService.deleteBlockedDate(newBlockedDate).pipe(takeUntil(this.unsubscribe$)).subscribe(
                responseData => {
                    if (responseData['error']) {
                        console.log('deleting blocked_date error');
                    } else {
                        // save log
                        const newLog = new LogCreate(this.user.id, 'Blocked date ' + value.date + ' ' +
                            new DispatchGroupTitlePipe(this.routeService).transform(value.dispatch_group_id) +
                            ' removed. ', this.ipAddress);
                        newLog.blocked_date_id = responseData['id'];
                        this.dataStorageService.createLog(newLog)
                            .pipe(takeUntil(this.unsubscribe$))
                            .subscribe(response => {
                                alert('blocked_date deleted. ');
                                location.reload();
                            });
                    }
                }
            );
        }
    }

    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
